import { type FC } from 'react';

import { ReactQueryDevtoolsLoadable } from '../ReactQueryDevtoolsLoadable';

import styles from './ReactQueryDevtools.css';

export const ReactQueryDevtools: FC = () => (
  <ReactQueryDevtoolsLoadable>
    {(Lib): JSX.Element => (
      <Lib.ReactQueryDevtools position="bottom-right" toggleButtonProps={{ className: styles['toggle-button'] }} />
    )}
  </ReactQueryDevtoolsLoadable>
);
